/**
 * Currently available feature flags.
 * The feature flags is written in pairs of:
 * LOCAL_KEY: "foreign-key", where "foreign-key" refers to keys coming from e.g. Stripe.
 *
 * @example property-check-sales-prices could be added to Stripe's metadata as a value for the key "feature-flags".
 */
export const FEATURE_FLAGS = {
  SALES_PRICES_ENABLED: "property-check-sales-prices",
  PROPERTIES_ENABLED: "properties",
  COMPANIES_V2_ENABLED: "companies-v2",
} as const;
